var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRetail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62,70.75a.7502.7502,0,0,0,.75-.75V22a.7502.7502,0,0,0-.75-.75H52.71191a12.733,12.733,0,0,0-25.42382,0H18a.7502.7502,0,0,0-.75.75V70a.7502.7502,0,0,0,.75.75Zm-22-60a11.26542,11.26542,0,0,1,11.22559,10.5H28.77441A11.26542,11.26542,0,0,1,40,10.75Zm-21.25,12h42.5v46.5H18.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40,34.75A5.25605,5.25605,0,0,1,45.25,40h1.5a6.7582,6.7582,0,0,0-6-6.70581V30h-1.5v3.29419A6.74874,6.74874,0,0,0,40,46.75,5.25,5.25,0,1,1,34.75,52h-1.5a6.7582,6.7582,0,0,0,6,6.70581V62h1.5V58.70581A6.74874,6.74874,0,0,0,40,45.25a5.25,5.25,0,0,1,0-10.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRetail);
export default __webpack_public_path__ + "static/media/icon_retail.8cd6907fe934c432b75815a39bcabdbf.svg";
export { ForwardRef as ReactComponent };